import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/artykul/kakobuy-sheet-kompletny-przewodnik/page";
import CssbuyComparisonPage from "../pages/artykul/cssbuy-vs-kakobuy-porownanie-spreadsheet/page";
import SafeShoppingPage from "../pages/artykul/kakobuy-bezpieczne-zakupy-poradnik/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-sheet-kompletny-przewodnik",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/cssbuy-vs-kakobuy-porownanie-spreadsheet",
    element: <CssbuyComparisonPage />,
  },
  {
    path: "/artykul/kakobuy-bezpieczne-zakupy-poradnik",
    element: <SafeShoppingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;